import React from "react";
import { Table, Input, Button, Modal, Form } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import useClassRooms from "../../../hooks/AdminDashboard/useClassRooms";

function ClassRooms() {
	const {
		setSearchTerm,
		isModalVisible,
		modalType,
		selectedClassroom,
		form,
		filteredClassrooms,
		showModal,
		handleModalConfirm,
		handleModalCancel,
	} = useClassRooms();

	const columns = [
		{ title: "Course Title", dataIndex: "title", key: "title" },
		{ title: "Teacher", dataIndex: "teacher", key: "teacher" },
		{ title: "Session Time", dataIndex: "sessionTime", key: "sessionTime" },
		{
			title: "Actions",
			key: "actions",
			render: (_, record) => (
				<span className="space-x-2">
					<Button
						icon={<EyeOutlined />}
						onClick={() => showModal("view", "course", record)}
					/>
				</span>
			),
		},
	];

	const renderFormContent = () => {
		switch (modalType) {
			case "view":
				return (
					<div style={{ padding: "20px", fontSize: "16px" }}>
						<h3
							style={{
								marginBottom: "20px",
								textAlign: "center",
								color: "#1890ff",
							}}
						>
							Classroom Details
						</h3>
						<div
							style={{
								display: "grid",
								gridTemplateColumns: "1fr 1fr", // Two columns layout
								gap: "20px",
								marginBottom: "20px",
							}}
						>
							<div
								style={{
									borderBottom: "1px solid #e8e8e8",
									paddingBottom: "10px",
								}}
							>
								<strong style={{ fontSize: "18px" }}>
									Chosen Course:
								</strong>
								<p style={{ margin: "5px 0", color: "#555" }}>
									{selectedClassroom?.title}
								</p>
							</div>
							<div
								style={{
									borderBottom: "1px solid #e8e8e8",
									paddingBottom: "10px",
								}}
							>
								<strong style={{ fontSize: "18px" }}>
									Teacher:
								</strong>
								<p style={{ margin: "5px 0", color: "#555" }}>
									{selectedClassroom?.teacher}
								</p>
							</div>
							<div
								style={{
									borderBottom: "1px solid #e8e8e8",
									paddingBottom: "10px",
								}}
							>
								<strong style={{ fontSize: "18px" }}>
									Schedule Dates:
								</strong>
								<div style={{ margin: "5px 0", color: "#555" }}>
									{selectedClassroom?.schedules.map(
										(schedule, ind) => (
											<p key={ind}>
												{schedule.scheduleDate}
											</p>
										)
									)}
								</div>
							</div>
							<div
								style={{
									borderBottom: "1px solid #e8e8e8",
									paddingBottom: "10px",
								}}
							>
								<strong style={{ fontSize: "18px" }}>
									Session Time:
								</strong>
								<p style={{ margin: "5px 0", color: "#555" }}>
									{selectedClassroom?.sessionTime}
								</p>
							</div>
							<div
								style={{
									borderBottom: "1px solid #e8e8e8",
									paddingBottom: "10px",
								}}
							>
								<strong style={{ fontSize: "18px" }}>
									Assigned At:
								</strong>
								<p style={{ margin: "5px 0", color: "#555" }}>
									{selectedClassroom?.assignedAt}
								</p>
							</div>
						</div>
					</div>
				);
			case "createMeeting":
				return (
					<div className="w-full max-w-md bg-white rounded-lg p-8">
						<h2 className="text-2xl font-bold text-blue-600 mb-4">
							Create a Meeting
						</h2>
						<p className="text-gray-600 mb-6">
							Please provide the following details to proceed.
						</p>
						<form className="space-y-4">
							<div>
								<label
									htmlFor="email"
									className="block text-gray-700 font-medium mb-1"
								>
									Email
								</label>
								<input
									type="email"
									id="email"
									placeholder="Enter your email"
									className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
								/>
							</div>
							<div>
								<label
									htmlFor="firstName"
									className="block text-gray-700 font-medium mb-1"
								>
									First Name
								</label>
								<input
									type="text"
									id="firstName"
									placeholder="Enter your first name"
									className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
								/>
							</div>
							<div>
								<label
									htmlFor="lastName"
									className="block text-gray-700 font-medium mb-1"
								>
									Last Name
								</label>
								<input
									type="text"
									id="lastName"
									placeholder="Enter your last name"
									className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
								/>
							</div>
						</form>
					</div>
				);

			default:
				return null;
		}
	};

	return (
		<div className="p-6 bg-white">
			<h2 className="text-2xl font-bold mb-4">ClassRooms List</h2>
			{/* Filters */}
			<div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4">
				<Input.Search
					placeholder="Search by classroom name..."
					onChange={(e) => setSearchTerm(e.target.value)}
					className="w-full"
				/>
				<Button
					type="primary"
					onClick={() => showModal("createMeeting", "course")}
				>
					<p>Create Classroom Meetings</p>
				</Button>
			</div>
			<Table
				dataSource={filteredClassrooms}
				columns={columns}
				rowKey="id"
				pagination={false}
			/>

			<Modal
				title={`${
					modalType === "view" ? "View" : "createMeeting"
				} Course`}
				open={isModalVisible}
				onOk={handleModalConfirm}
				onCancel={handleModalCancel}
				okText="Save"
				cancelText="Cancel"
				footer={modalType === "view" ? null : undefined}
			>
				<Form form={form} layout="vertical">
					{renderFormContent()}
				</Form>
			</Modal>
		</div>
	);
}

export default ClassRooms;
